import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import { KeyboardArrowRight } from '@mui/icons-material'
import { useUserContext } from '../Contexts/UserConfig'
import { darkMode } from '../Functions/GetColourPalette'
import { tsMenuItem } from '../Typescript/UI_Interfaces'
import { useLocation, useNavigate } from 'react-router-dom'
import { drawer } from '../garvan-react/Constants/StyleConstants'

function DrawerMenuItem({
  current,
  setItems,
}: {
  current: tsMenuItem
  setItems: any
}) {
  const { loginConfig } = useUserContext()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  let textWidth = drawer - 30
  if (current.leftIcon && current.nestedItems) {
    textWidth = drawer - 100
  } else if (current.leftIcon || current.nestedItems) {
    textWidth = drawer - 80
  }

  return (
    <ListItemButton
      selected={current.path === pathname} //Use pathname
      onClick={() => {
        if (current?.nestedItems) {
          setItems((i: any) => {
            return {
              currentItems: current.nestedItems,
              parentItems: i.currentItems,
            }
          })
        }
        if (current.path !== pathname) {
          navigate(current.path)
        }
      }}
    >
      {current.leftIcon && (
        <ListItemIcon sx={{ color: 'inherit', minWidth: 45 }}>
          <Badge
            badgeContent={current.badgeCount}
            color="primary"
          >
            {current.leftIcon}
          </Badge>
        </ListItemIcon>
      )}
      <Stack sx={{ width: textWidth }}>
        <ListItemText
          primary={current.primaryText}
          primaryTypographyProps={{
            color: 'primary' + (darkMode(loginConfig) ? '.light' : ''),
          }}
          // Not using 'secondary' as you are unable to split on \n
        />
        {(current?.secondaryText ?? '')?.split('\n').map((l) => (
          <Typography
            variant={'caption'}
            sx={{ fontSize: 13 }}
            key={l}
          >
            {l}
          </Typography>
        ))}
      </Stack>
      {current?.nestedItems && (
        <KeyboardArrowRight
          color={'primary'}
          sx={{ mr: -1 }}
        />
      )}
    </ListItemButton>
  )
}

export default DrawerMenuItem
